import * as maska from 'maska'

//Just to make it compile but doesn't work
export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.directive("maska", maska)
})
